import styled from 'styled-components';
import bp from 'Styles/breakpoints';

export const SlidingPanelDrawer = styled.div`
  overflow: hidden;
  position: relative;
  height: 100%;

  ${bp('medium')} {
    /* This is the maximum height of Modal. */
    height: 85vh;
    max-height: 668px;
  }
`;

export default SlidingPanelDrawer;
